const list = {
    or: 'oder',
    and: 'und',
    separator: ',',
};
export default Object.freeze(list);
